<template>
    <div>
        <Button icon="md-cloud-download" type="primary" ghost @click="exportMeterInfoTemplate">导出设备模板</Button>
        <Upload ref="upload" name="upfile" action="/api/importMeterInfoTemplate" :on-success="handleImportMeterInfoTemplate"
            :format="['xlsx','xls']" :show-upload-list="false" :on-error="handleError">
            <Button type="primary" ghost icon="md-cloud-upload">按设备模板导入</Button>
        </Upload>
        <Button icon="md-cloud-download" type="primary" ghost @click="exportCustomerTemplate">导出用户模板</Button>
        <Upload ref="upload" name="upfile" action="/api/importCustomerTemplate" :on-success="handleImportCustomerTemplate"
            :format="['xlsx','xls']" :show-upload-list="false">
            <Button type="primary" ghost icon="md-cloud-upload">按用户模板导入</Button>
        </Upload>
        <Button icon="md-cloud-download" type="primary" ghost @click="exportAddressTemplate">导出地址模板</Button>
        <Upload ref="upload" name="upfile" action="/api/importAddressTemplate" :on-success="handleImportAddressTemplate"
            :format="['xlsx','xls']" :show-upload-list="false">
            <Button type="primary" ghost icon="md-cloud-upload">按地址模板导入</Button>
        </Upload>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                meterInfoUrl: "/api/downloadMeterInfoTemplate",
                customerUrl: "/api/downloadCustomerTemplate",
                addressUrl: "/api/downloadAddressTemplate"
            }
        },
        methods: {
            exportMeterInfoTemplate() {
                window.location.href = this.meterInfoUrl;
            },
            handleImportMeterInfoTemplate(response, file, fileList) {
                console.log(response);
                console.log(file);
                console.log(fileList);
                this.handelResponse(response);
            },
            exportCustomerTemplate() {
                window.location.href = this.customerUrl;
            },
            handleImportCustomerTemplate(response, file, fileList) {
                console.log(response);
                console.log(file);
                console.log(fileList);
                this.handelResponse(response);
            },
            exportAddressTemplate() {
                window.location.href = this.addressUrl;
            },
            handleImportAddressTemplate(response, file, fileList) {
                console.log(response);
                console.log(file);
                console.log(fileList);
                this.handelResponse(response);
            },
            handelResponse(response) {
                if (response.errorCode != 0) {
                    this.$Notice.error({
                        title: "导入失败",
                        desc: response.errorInfo,
                        duration: 0
                    });
                } else {
                    let result = response.body.repeatArray;
                    let insert = response.body.insertArray;
                    let count = "\n共计导入" + insert.length + "条数据。";
                    let indexs = "";
                    if (result.length > 0) {
                        result.map(item => {
                            indexs = indexs == "" ? (item.index + 2) : indexs + "," + (item.index + 2);
                        });
                    }
                    let msg = indexs == "" ? "" : "\n第" + indexs + "行数据与数据库中数据重复,不予导入。"
                    this.$Notice.success({
                        title: "成功",
                        desc: "导入成功！" + msg + count,
                        duration: 0
                    });
                }
            },
            handleError(error, file, fileList) {
                console.log(error);
                console.log(file);
                console.log(fileList);
                this.$Notice.error({
                    title: "导入失败",
                    desc: error,
                    duration: 0
                });
            }
        }
    }
</script>

<style>
</style>
